import React, { useState, useEffect } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import moment from "moment";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import UserPrefsService from "../../services/UserPrefsService";

const UserState = (props) => {
   let userPrefsService = new UserPrefsService();
   const [userPrefs, setUserPrefs] = useState({});

   useEffect(() => {
      checkuserTerr();
      fetchUserPrefs();
   }, []);

   useEffect(() => {
      if (props.call_refresh_user_data) {
         fetchUserPrefs();
         checkuserTerr();
         props.setCallRefreshUserData(false);
      }
   }, [props.call_refresh_user_data]);

   const fetchUserPrefs = async () => {
      try {
         let result = await axios.get("/Api/user");
         let basicInitPrefs = userPrefsService.getInitialesPrefs();
         result.data?.prefs && result.data?.prefs !== ""
            ? setUserPrefs(result.data.prefs)
            : setUserPrefs(userPrefsService.getInitialesPrefs());
         props.updateUserStatus({ prefs: { ...basicInitPrefs, ...result.data.prefs } });
         
      } catch (e) {
         console.log(e);
      }
   };

   useEffect(() => {
      const args = {
         userPrefs: props.userPrefs,
      };
      if (props.showCenterSection === "center_zone") {
         /*
            toast.promise(
                axios.post('/Api/user/prefs', args),
                {
                    loading: 'Enregistrement...',
                    success: <b>Préférences sauvegardées!</b>,
                    error: <b>Impossible d'enregistrer les modifications!.</b>,
                },
                {id: "prefs"}
            )

             */

         axios.post("/Api/user/prefs", args);
      } else {
         axios.post("/Api/user/prefs", args);
      }
   }, [props.userPrefs]);

   const checkuserTerr = () => {
      axios
         .get("/Api/user")
         .then((result) => {
            if (result.data && result.data.id) {
               // Update user status with the retrieved data
               props.updateUserStatus(result.data);
           
               const entity = result.data.entity;
               const subscriptions = entity?.subscriptions;
               const genreSlug = entity?.genre?.slug;
               // Function to handle setting entity-related props
               const setEntityProps = (entityData) => {
                   props.setCurrentEntity(entityData);
                   props.setCurrentComLabel(entityData.city);
                   try {
                       const codes_terr = JSON.parse(entityData.codes_terr);
                       if (Array.isArray(codes_terr) && codes_terr.length > 0) {
                           props.setCurrentCom(codes_terr[0].code);
                       }
                   } catch (error) {
                       console.error("Error parsing codes_terr:", error);
                       // Optionally handle the error, e.g., show a notification
                   }
               };
           
               // Check if the user's genre is 'collective' or 'professionnel'
               if (genreSlug === "collective") {
                   if (subscriptions && subscriptions.length > 0) {
                       
                       okSubscriber(subscriptions[0]);
                   } else {
                       // User does not have a valid subscription; show the popup
                       infoUSer();
                       // Optionally, you can return early if further execution depends on a valid subscription
                       // return;
                   }
               } else if (genreSlug === "professionnel") {
                  const currentSub = result.data.currentSubscription;
                  if (currentSub) {
                      
                      okSubscriber(currentSub);
                  } else {
                      // User does not have a valid subscription; show the popup
                      infoUSer();
                      // Optionally, you can return early if further execution depends on a valid subscription
                      // return;
                  }
               } else {
                   // Handle other genres as needed
                   if (subscriptions && subscriptions.length > 0) {
                       okSubscriber(subscriptions[0]);
                   } else {
                       // Decide what to do if other genres lack subscriptions
                       // For example, you might also want to show infoUSer() or handle differently
                       infoUSer();
                   }
               }
           
               // Set the current entity properties regardless of subscription status
               if (entity) {
                   setEntityProps(entity);
               }
           }
           
         })
         .catch((err) => {
            console.log(err);
         });
   };

   const updateInitCom = (codeCom) => {
      const params = {
         code_com: codeCom.code,
      };

      axios
         .post("/Api/geodata/geom/commune", params)
         .then((result) => {
            props.updateVectorLayer(JSON.parse(result.data[0].json_build_object), "commune", false);
            props.cleanVectorLayer(true);
         })
         .catch((err) => {
            console.log(err);
         });
   };

   const infoUSer = () => {
      const htmlInfo =
         "<div>" +
         '<h4 class="text-primary font-weight-bold">Vous êtes bien connecté </h4></div' +
         "><div><p>Actuellement votre compte ne vous permet d'accéder qu'aux fonctions de base de l'application.</p></div> " +
         "<div><p>Abonnez-vous pour profiter de l'ensemble des fonctionnalités</p></div>";

      const ConfirmLoginSwal = withReactContent(Swal);

      ConfirmLoginSwal.fire({
         icon: "success",
         html: htmlInfo,
         showCloseButton: true,
         showCancelButton: true,
         confirmButtonText: "S'abonner",
         confirmButtonColor: "#58D2C3",
         cancelButtonText: "Continuer",
         cancelButtonColor: "#a4a09c",
      }).then((result) => {
         result.isConfirmed ? props.setShowPricing(true) : null;
      });
   };

   const okSubscriber = (infoSubscription) => {
      /*
        moment.locale('fr')
        let endDate = null
        let startDate = moment(infoSubscribtion.start_at)
        //let subscribType = infoSubscribtion.subscription_types_id
        */
      //console.log(infoSubscribtion)
      props.updateUserStatus({ subscription: infoSubscription });

      /*
        let htmlInfo = '<div><h4 class="text-primary font-weight-bold">Vous êtes bien abonné </h4></div>'
        htmlInfo += (startDate)? '<div><p>depuis le <b class="">'+ startDate.format('DD/MM/YYYY')+'</b></p></div>':''

        withReactContent(Swal).fire({
            icon: 'success',
            html: htmlInfo,
            showCloseButton: true,
            confirmButtonColor: '#e57f13',
            confirmButtonText: 'Continuer',
        }).then(()=>{
            //this.map.render();
        })
         */
   };

   return <div></div>;
};

const mapStateToProps = (state) => {
   return {
      userPrefs: state.MeReducer?.prefs,
      showCenterSection: state?.LeftPanelReducer?.showCenterSection,
      call_refresh_user_data: state.MeReducer?.call_refresh_user_data,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      //handleSubscribProcess: () => dispatch( {type: 'TOGGLE_SUBSCRIB_MODAL'}),
      updateUserStatus: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
      setCurrentEntityId: (e) => dispatch({ type: "SET_CURRENT_ENTITY", data: { currentEntity: e } }),
      setCurrentCom: (e) => dispatch({ type: "SET_CURRENT_COM", data: { currentCom: e } }),
      setCurrentComLabel: (e) => dispatch({ type: "SET_CURRENT_COM_LABEL", data: { currentComLabel: e } }),
      updateVectorLayer: (e, t) => dispatch({ type: "UPDATE_VECTOR_LAYER", data: { geoJsonData: e, typeTerr: t } }),
      cleanVectorLayer: (e) => dispatch({ type: "CLEAR_VECTOR_LAYER", data: e }),
      setCurrentEntity: (e) => dispatch({ type: "SET_CURRENT_ENTITY", data: { currentEntity: e } }),
      setShowPricing: (e) => dispatch({ type: "SET_SHOW_PRICING", data: e }),
      setCallRefreshUserData: (e) => dispatch({ type: "SET_CALL_REFRESH_USER_DATA", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(UserState);
